import React from "react";
import { BasicDetailsTypes } from "../../../types/profile";

interface BasicDetailsProps {
  chatUserDetails: BasicDetailsTypes;
  onOpenCustomer: () => void;
}
const BasicDetails = ({ chatUserDetails, onOpenCustomer }: BasicDetailsProps) => {

  //Nome do contato
  const fullName =
    chatUserDetails.name === undefined
      ? chatUserDetails.firstName
      : chatUserDetails.name;

  return (
    <div className="pb-2">
      <h5 className="font-size-11 text-uppercase mb-2">Informações :</h5>
      <div>

        <div className="d-flex align-items-end">
          <div className="flex-grow-1">
            <p className="text-muted font-size-14 mb-1">Nome</p>
          </div>
          <div className="flex-shrink-0">
            <button type="button" className="btn btn-sm btn-soft-primary" onClick={onOpenCustomer}>
              Editar
            </button>
          </div>
        </div>
        <h5 className="font-size-14">{fullName}</h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">Região</p>
        <h5 className="font-size-14">
          {chatUserDetails.idRegiao ? chatUserDetails.regiao : "-"}
        </h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">Endereço</p>
        <h5 className="font-size-14">
          {chatUserDetails.address ? chatUserDetails.address : "-"}
        </h5>
      </div>

      <div className="mt-4">
        <p className="text-muted font-size-14 mb-1">Observação</p>
        <h5 className="font-size-14 mb-0">
          {chatUserDetails.obs ?? chatUserDetails.obs}
        </h5>
        <p className="text-muted font-size-14 mb-1">Atendimento</p>
        <h5 className="font-size-14 mb-0">
          {chatUserDetails.obsAtendimento ?? chatUserDetails.obsAtendimento}
        </h5>
      </div>
    </div>
  );
};

export default BasicDetails;
